import React from 'react';
import Head from 'next/head';
import { getFaqSchema } from '@/utils/seo';
import { IItemProps } from './IFAQS';

function SchemaMarkup({ items }: { items: IItemProps[] }) {
  const scheme = getFaqSchema(items);

  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: scheme }} />
    </Head>
  );
}

export default SchemaMarkup;
